<template>
  <div class="panel vaccine-coverage-panel">
    <h4 class="panel-title">Cobertura por Vacina</h4>

    <ul class="coverage-list list-unstyled">
      <li v-for="(vaccine, index) in coverage" :key="vaccine.id_vacina" class="coverage-item">
        <div class="coverage-header d-flex align-items-center justify-content-between">
          <span class="coverage-name" :title="vaccine.nome">{{ vaccine.nome }}</span>
          <span class="coverage-value">{{ formatPercentage(vaccine.percentual_cobertura) }}</span>
        </div>

        <div
          class="coverage-track"
          role="progressbar"
          :aria-label="`Cobertura da vacina ${vaccine.nome}`"
          :aria-valuenow="vaccine.percentual_cobertura"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div
            class="coverage-progress"
            :style="{ width: progressWidth(vaccine.percentual_cobertura), backgroundColor: colors[index] }"
          />
        </div>

        <span class="coverage-detail d-block">
          {{ vaccine.doses_aplicadas | addDots }} de {{ vaccine.doses_aderidas | addDots }} doses aplicadas
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import dashUtilsMixin from '@/views/custom-pages/dashboard/shared-mixins/dashUtilsMixin'
import vaccineColorsMixin from '@/views/custom-pages/dashboard/shared-mixins/vaccineColorsMixin'

export default {
  mixins: [dashUtilsMixin, vaccineColorsMixin],

  props: {
    panelData: {
      type: Array,
      default: () => [],
    },

    colorMap: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    coverage() {
      return this.panelData
    },

    colors() {
      const fallbackColors = this.generateColors(this.coverage.length)

      return this.coverage.map(
        (vaccine, index) => this.colorMap[Number(vaccine.id_vacina)] || fallbackColors[index],
      )
    },
  },

  methods: {
    formatPercentage(percentual) {
      const valor = Number(percentual) || 0

      return `${valor.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`
    },

    progressWidth(percentual) {
      const valor = Math.min(Math.max(Number(percentual) || 0, 0), 100)

      return `${valor}%`
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@/assets/scss/_responsivity.scss";

.vaccine-coverage-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: auto;
  max-height: responsive-height(420px);
}

.coverage-list {
  margin: responsive-height(16px) 0 0;
  padding-right: responsive-width(4px);
  overflow-y: auto;
}

.coverage-item + .coverage-item {
  margin-top: responsive-height(14px);
}

.coverage-header {
  column-gap: responsive-width(8px);
}

.coverage-name {
  font-size: responsive-height(14px);
  line-height: responsive-height(20px);
  color: $text-body-color;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.coverage-value {
  flex-shrink: 0;
  font-size: responsive-height(16px);
  line-height: responsive-height(20px);
  font-weight: 500;
  color: $text-base-color;
}

.coverage-track {
  height: responsive-height(8px);
  margin-top: responsive-height(6px);
  background-color: $progress-track-color;
  border-radius: responsive-height(4px);
  overflow: hidden;
}

.coverage-progress {
  height: 100%;
  border-radius: responsive-height(4px);
  transition: width 0.4s ease;
}

.coverage-detail {
  margin-top: responsive-height(4px);
  font-size: responsive-height(12px);
  line-height: responsive-height(16px);
  color: $placeholder-color;
}

@media only screen and (max-width: 780px) {
  .coverage-list {
    margin-top: mobile-responsive-height(12px);
  }

  .coverage-item + .coverage-item {
    margin-top: mobile-responsive-height(12px);
  }
}
</style>
